import { tWithKeyAttr as t } from "../../i18nHelper";
import styles from "./addExerciseToUser.module.css";
import BackArrowButton from "../backArrowButton/backArrowButton";
import Select from "react-select";
import { useEffect, useState } from "react";
import { TExercise } from "../../utils/constants";
import { useGetExercisesMutation } from "../../services/api/utils.api";
import { useAppSelector } from "../../services/hooks";
import { adminSelector } from "../../services/selectors/user.selectors";
import {
  exercisesCategoriesSelectOptionsSelector,
  // exercisesCategoriesSelector,
  exercisesSelector,
} from "../../services/selectors/utils.selectors";
import { TLabeledItemWithId } from "../../types/types";

function AddExerciseToUser({ onClose }: { onClose: () => void }) {
  const admin = useAppSelector(adminSelector);
  const exercises = useAppSelector(exercisesSelector);
  const exercisesCategoriesSelectOptions: TLabeledItemWithId[] = useAppSelector(
    exercisesCategoriesSelectOptionsSelector
  );

  const [chosen, setChosen] = useState<TExercise[]>([]);
  const [getExercises] = useGetExercisesMutation();

  useEffect(() => {
    if (admin) {
      getExercises();
    }
  }, [admin, getExercises]);

  return (
    <section className={styles.section}>
      <BackArrowButton
        text={t("BACK_BUTTON_TEXT")}
        position={"center"}
        onClick={onClose}
      />
      <h3 className={`title`}>{t("EXERCISES_TITLE")}</h3>
      <div className={styles.header}>
        <Select
          placeholder={t("FILTER_PLACEHOLDER")}
          options={exercisesCategoriesSelectOptions}
          // defaultValue={exerciseCategories[0]}
        />
        <input type={"text"} className={`input`} placeholder={t("SEARCH_PLACEHOLDER")} />
      </div>
      <div className={styles.exercises}>
        <ul className={`${styles.list} ${styles.list_all}`}>
          {exercises.map((e) => (
            <li>{e.title}</li>
          ))}
        </ul>
        <ul className={`${styles.list} ${styles.list_chosen}`}>
          {chosen.length > 0
            ? chosen.map((c) => <li>{c?.title}</li>)
            : t("DRAG_EXERCISES_MESSAGE")}
        </ul>
      </div>
    </section>
  );
}

export default AddExerciseToUser;
